export default __webpack_public_path__ + "static/media/sustainability-img-dt@2x.e047a661.jpg";